import { z } from 'zod';
const BaseExportValidationSchema = z.object({
    tools: z.string(),
    imageOnly: z.string().optional()
});
const ExportValidationSchema = BaseExportValidationSchema;
export { ExportValidationSchema };
//# sourceMappingURL=export.js.map